import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Edit as EditIcon } from '@mui/icons-material';
import {
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import {
  CheckCircle,
  Cancel,
  Visibility,
  AddCircleOutline,
  Visibility as VisibilityIcon,
  PendingActions,
  Comment,
  Reviews
} from '@mui/icons-material';
import axios from 'axios';
import LoadingScreen from './LoadingScreen';

const Request = () => {
const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editRequestId, setEditRequestId] = useState(null);


  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [closeComment, setCloseComment] = useState('');
  const [closingRequestId, setClosingRequestId] = useState(null);

  const token = localStorage.getItem('token');
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [criticality, setCriticality] = useState('');
  const [justification, setJustification] = useState('');

  const [view, setView] = useState('raise');
  const [industries, setIndustries] = useState([]);
  const [industry, setIndustry] = useState('');
  const [helpneed, sethelpneed] = useState('');
  const [helpneedlst, sethelpneedlst] = useState([]);
  const [question, setQuestion] = useState('');
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [answer, setAnswer] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageSize, setPageSize] = useState(10);  // Default to 10 rows per page
  const [page, setPage] = useState(0);
  const username = localStorage.getItem('username') || 'Anonymous';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen size is mobile
  const [requestTo, setRequestTo] = useState('');
  const [moderatorType, setModeratorType] = useState('');
  const [answers, setAnswers] = useState([]);
  const [isprovider] = useState(localStorage.getItem('isprovider'));

  const [requestnumber, serrequestnumber] = useState('');

  // const [resumeFile,setresumeFile]=useState([''])
  const [resumeFiles, setResumeFiles] = useState([]);
  const [uploadedResumeFiles,setUploadedResumeFiles]=useState([])
  const [deletedFileIds, setDeletedFileIds] = useState([]);

  useEffect(() => { 
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(() => setIsAdmin(true)).catch(() => setIsAdmin(false));
    }
  }, []);

  const handleEditRequest = async (request) => {
  //getfile list
  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${request.id}/attachments`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  setUploadedResumeFiles(response.data); 

  serrequestnumber(request.request_number)
  setRequestTo(request.requestTo);
  setIndustry(request.industry);
  sethelpneed(request.helpneed)
  setQuestion(request.question);
  setCriticality(request.criticality || '');
  setJustification(request.justification || '');
  setModeratorType(request.moderatorType || '');
  setEditRequestId(request.id);
  setResumeFiles([])
  setIsEditing(true);
  setView('raise');

  };


  const handleRequestToChange = async (e) => {
    const value = e.target.value;
    setRequestTo(value); 
    if (value === 'Providers') {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/checkOpenRequests`, {
          headers: { Authorization: `Bearer ${token}` }
        });
  
        const hasOpenRequest = response.data?.hasOpenRequest;
  
        if (hasOpenRequest) {
          alert("You have an open request. Please close it to create a new one.");
          setRequestTo(''); // Reset the selection
        }
  
      } catch (error) {
        console.error("Error checking open requests", error);
        alert("Failed to check open requests.");
      }
    }
  };
  

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getIndustries`)
      .then((res) => setIndustries(res.data.industries))
      .catch((err) => console.error('Error fetching industries', err));
  }, []);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/gethelpneeded`)
      .then((res) => sethelpneedlst(res.data.industries))
      .catch((err) => console.error('Error fetching industries', err));
  }, []);
  const handleViewClick = async (request) => {
    setSelectedRequest(request);
    try {
       setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getAnswersForRequest/${request.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const response_attachment = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${request.id}/attachments`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUploadedResumeFiles(response_attachment.data|| []); 
      setAnswers(response.data || []);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching answers', err);
      setIsLoading(false);
    }
     
  };  
  const handleSubmit = () => {
    if (criticality === 'High' && !justification) {
      alert('Please provide justification for high criticality.');
      return;
    }

      const formData = new FormData();
    // Append basic fields
      formData.append('requestTo', requestTo);
      if (requestTo === 'Providers') {
        formData.append('helpneed', helpneed);
        formData.append('industry', industry);
        formData.append('criticality', criticality);
        if (criticality === 'High') {
          formData.append('justification', justification);
        }else{
          formData.append('justification', '');
        }
      } else if (requestTo === 'Moderators') {
        formData.append('moderatorType', moderatorType);
      }
      formData.append('question', question);
      // Append multiple files
      resumeFiles.forEach((file, index) => {
        formData.append('attachments', file); // name 'attachments' should match backend field name
      });
      formData.append('deletedFileIds', JSON.stringify(deletedFileIds))
      formData.append('request_number', requestnumber)
      const requestCall = isEditing
      ? axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateRequest/${editRequestId}`, formData, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data', },
        })
      : axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/submitRequest`, formData, {
          headers: { Authorization: `Bearer ${token}`}
        });
        
    requestCall
      .then(() => {
        alert(isEditing ? 'Request updated successfully!' : 'Request submitted successfully!');
        setRequestTo('')
        setModeratorType('')
        setIndustry('');
        setQuestion('');
        setCriticality('');
        setJustification('');
        setEditRequestId(null);
        setIsEditing(false);
        setResumeFiles([])
        setUploadedResumeFiles([])
        setDeletedFileIds([])
        setView('view');
      })
      .catch(() => alert('Submission failed.'));
  };

  useEffect(() => {
    const fetchRequests = async () => {
       setIsLoading(true);
      try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/getRequests`; 
        if (view === 'view') {
          if(isAdmin){
            url += '?get=all'
          }else{
            url += '?get=user'
          } 
        } else if (view === 'pendingApproval') {
          url += `?status=Pending Approval`;
        } else if (view === 'pendingComments') {
          url += `?status=Approved`;
        }  
        else if (view === 'feedbacks') {
          url += `?type=providers`;
        }  
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setRequests(response.data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error fetching requests', err);
        setIsLoading(false);
      } 
    };  
    if(view !== 'raise'){
      setRequests([]) 
      fetchRequests();
      setRequestTo('')
        setModeratorType('')
        setIndustry('');
        setQuestion('');
        setCriticality('');
        setJustification('');
        setEditRequestId(null);
        setResumeFiles([])
        setUploadedResumeFiles([])
        setIsEditing(false);
    } 
  }, [view, username, refreshFlag, isAdmin, token]);

  const handleApproval = (id, status) => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateRequestStatus/${id}`, {
      id, status
    },{
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert(`Request ${status.toLowerCase()} successfully!`);
      setRequests((prev) => prev.map((r) => (r.id === id ? { ...r, status, approvedBy: username } : r)));
    }).catch(() => alert('Failed to update request status'));
  };

  const handleAnswerSubmit = (id,request_number) => {
    if (!answer) return alert('Answer is required');
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/updateAnswer`, {
      requestId: id,
      answer, 
      requestnumber:request_number
    },{
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert('Answer submitted successfully!');
      setAnswer('');
      setSelectedRequest(null); 
      setRefreshFlag(prev => !prev);
    }).catch(() => alert('Failed to submit answer'));
  };


  const openCloseDialog = (id) => {
    setClosingRequestId(id);
    setCloseDialogOpen(true);
  };
  
  const handleCloseRequest = () => {
    if (!closeComment.trim()) {
      alert("Please provide a comment to close the request.");
      return;
    } 
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/closeRequest/${closingRequestId}`, {
      comment: closeComment,      
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert("Request closed successfully!");
      setCloseDialogOpen(false);
      setCloseComment('');
      setClosingRequestId(null);
      setRefreshFlag(prev => !prev);
    }).catch(() => {
      alert("Failed to close request.");
    });
  };

  const columns = [
    ...(view === 'view' ? [{
      field: 'moderatorType',
      headerName: 'Type',
      flex: 1,
      minWidth: 150
    }] : [])
   ,
   {
      field: 'request_number', headerName: 'Request Number', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'helpneed', headerName: 'Help Need', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'industry', headerName: 'Industry', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'criticality',
      headerName: 'Criticality',
      width: 130,
      renderCell: (params) => {
        const value = params.value;
        const color =
          value === 'High' ? 'red' :
          value === 'Medium' ? 'orange' :
          'green';
        return (
          <span style={{ color, fontWeight: 'bold' }}>
            {value}
          </span>
        );
      },
    },
    {
      field: 'question', headerName: 'Question', flex: 2, minWidth: 250,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'submittedBy',
      headerName: 'Submitted By',
      width: 150,
    },
    {
      field: 'submittedDate',
      headerName: 'Submitted Date',
      width: 180,
      renderCell: (params) => {
        const rawDate = params.value;
        const date = new Date(rawDate);
    
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
    
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');
    
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      },
    }, 
    {
      field: 'answerCount', headerName: 'Answers', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },   
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 150,
      renderCell: (params) => (
        <Chip label={params.value} color={params.value === 'Pending Approval' ? 'warning' :
          params.value === 'Approved' ? 'success' :
            params.value === 'Rejected' ? 'error' : 'default'}
        />
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View">
            <IconButton onClick={() => handleViewClick(params.row)}>
              <Visibility />
            </IconButton>
          </Tooltip>
          {isAdmin && view === 'pendingApproval' && params.row.status === 'Pending Approval' && (
            <>
              <Tooltip title="Approve">
                <IconButton color="success" onClick={() => handleApproval(params.row.id, 'Approved')}>
                  <CheckCircle />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reject">
                <IconButton color="error" onClick={() => handleApproval(params.row.id, 'Rejected')}>
                  <Cancel />
                </IconButton>
              </Tooltip>
            </>
          )}
          {(view === 'view' || view === 'pendingComments') && params.row.status !== 'Closed' && params.row.status !== 'Rejected' && (
          <Tooltip title="Close Request">
            <IconButton onClick={() => openCloseDialog(params.row.id)}>
              <Reviews color="warning" />
            </IconButton>
          </Tooltip>
          )}
          {view === 'view' &&
          params.row.status !== 'Closed' && 
          params.row.status !== 'Rejected' && (
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEditRequest(params.row)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];
  const feedbackColumns = [
  { field: 'moderatorType', headerName: 'Type', flex: 1, minWidth: 150 },
  { field: 'question', headerName: 'Comments', flex: 2, minWidth: 250, cellClassName: 'wrap-text' },
  { field: 'submittedBy', headerName: 'Submitted By', width: 150 },
  {
    field: 'submittedDate',
      headerName: 'Submitted Date',
      width: 180,
      renderCell: (params) => {
        const rawDate = params.value;
        const date = new Date(rawDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      renderCell: (params) => (
        <Tooltip title="View Details">
          <IconButton onClick={() => setSelectedRequest(params.row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const isSubmitDisabled =
  !requestTo ||
  (requestTo === 'Moderators' && (!moderatorType || !question.trim())) ||
  (requestTo === 'Providers' &&
    (!helpneed || !industry || !criticality || !question.trim() || (criticality === 'High' && !justification.trim())));

  const formatSubmittedDate = (rawDate) => {
    if (!rawDate) return 'Not available';
    const date = new Date(rawDate);
    if (Number.isNaN(date.getTime())) return 'Not available';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
  };

  const viewTitleMap = {
    raise: isEditing ? 'Update your request' : 'Create a request',
    view: 'My request tracker',
    pendingComments: 'Open provider requests',
    pendingApproval: 'Requests pending approval',
    feedbacks: 'Feedback and issues',
  };

  const viewDescriptionMap = {
    raise: 'Choose who should receive your request, add enough context, and attach supporting documents when needed.',
    view: 'Track requests you have raised, review answers, close completed requests, or edit open items.',
    pendingComments: 'Review approved community requests and respond with clear guidance.',
    pendingApproval: 'Validate submitted requests before they are shared with providers.',
    feedbacks: 'Review user feedback and reported issues from one place.',
  };

  const requestStats = [
    { label: 'Active view', value: viewTitleMap[view] || 'Requests' },
    { label: 'Loaded items', value: requests.length },
    { label: 'Your role', value: isAdmin ? 'Admin' : isprovider === 'yes' ? 'Provider' : 'Member' },
  ];

  const renderMobileActions = (request) => (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
      <Button size="small" variant="outlined" startIcon={<Visibility />} onClick={() => handleViewClick(request)}>
        View
      </Button>
      {isAdmin && view === 'pendingApproval' && request.status === 'Pending Approval' && (
        <>
          <Button size="small" color="success" variant="contained" startIcon={<CheckCircle />} onClick={() => handleApproval(request.id, 'Approved')}>
            Approve
          </Button>
          <Button size="small" color="error" variant="outlined" startIcon={<Cancel />} onClick={() => handleApproval(request.id, 'Rejected')}>
            Reject
          </Button>
        </>
      )}
      {(view === 'view' || view === 'pendingComments') && request.status !== 'Closed' && request.status !== 'Rejected' && (
        <Button size="small" color="warning" variant="outlined" startIcon={<Reviews />} onClick={() => openCloseDialog(request.id)}>
          Close
        </Button>
      )}
      {view === 'view' && request.status !== 'Closed' && request.status !== 'Rejected' && (
        <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={() => handleEditRequest(request)}>
          Edit
        </Button>
      )}
    </Box>
  );
 return isLoading ? <LoadingScreen /> : (
    <Box
      sx={{
        minHeight: '100vh',
        mx: { xs: -2, sm: -3, md: -4 },
        my: { xs: -2, sm: -3, md: -4 },
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 3, md: 5 },
        background:
          'radial-gradient(circle at 12% 12%, rgba(20, 184, 166, 0.16), transparent 30%), radial-gradient(circle at 86% 8%, rgba(37, 99, 235, 0.14), transparent 28%), linear-gradient(135deg, #f8fafc 0%, #eef7f6 47%, #f8fafc 100%)',
      }}
    >
      <Box sx={{ maxWidth: 1240, mx: 'auto' }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: '1.5fr 1fr' },
            gap: 2.5,
            alignItems: 'stretch',
            mb: 3,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, md: 4 },
              borderRadius: 4,
              border: '1px solid rgba(15, 118, 110, 0.14)',
              boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
            }}
          >
            <Chip
              label="Udyog Connect Requests"
              sx={{
                mb: 2,
                bgcolor: '#e6fffb',
                color: '#0f766e',
                border: '1px solid #99f6e4',
                fontWeight: 800,
              }}
            />
            <Typography
              variant={isMobile ? 'h4' : 'h3'}
              sx={{ color: '#0f172a', fontWeight: 900, lineHeight: 1.08, mb: 1.5 }}
            >
              Ask, track, respond, and resolve with clarity.
            </Typography>
            <Typography sx={{ color: '#475569', maxWidth: 760, lineHeight: 1.7 }}>
              Use this workspace to raise community requests, share feedback with moderators,
              review provider responses, and keep every conversation easy to follow.
            </Typography>
          </Paper>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)', lg: '1fr' },
              gap: 1.5,
            }}
          >
            {requestStats.map((stat) => (
              <Paper
                key={stat.label}
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 3,
                  border: '1px solid rgba(15, 118, 110, 0.12)',
                  bgcolor: 'rgba(255, 255, 255, 0.82)',
                  boxShadow: '0 16px 40px rgba(15, 23, 42, 0.06)',
                }}
              >
                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, textTransform: 'uppercase' }}>
                  {stat.label}
                </Typography>
                <Typography sx={{ color: '#0f172a', fontWeight: 900, mt: 0.75 }}>
                  {stat.value}
                </Typography>
              </Paper>
            ))}
          </Box>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 1.5, sm: 2, md: 3 },
            borderRadius: 4,
            border: '1px solid rgba(15, 118, 110, 0.13)',
            boxShadow: '0 22px 70px rgba(15, 23, 42, 0.08)',
            overflow: 'hidden',
          }}
        >
      <Tabs
        value={view}
        onChange={(e, newValue) => setView(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 2.5,
          borderBottom: '1px solid #e2e8f0',
          minHeight: 54,
          '& .MuiTab-root': {
            minHeight: 54,
            textTransform: 'none',
            fontWeight: 800,
            color: '#475569',
            px: { xs: 1.25, sm: 2 },
          },
          '& .Mui-selected': { color: '#0f766e !important' },
          '& .MuiTabs-indicator': { bgcolor: '#0f766e', height: 3, borderRadius: 999 },
        }}
      >
        <Tab value="raise" icon={<AddCircleOutline />} iconPosition="start" label="Raise Request" />
        <Tab value="view" icon={<VisibilityIcon />} iconPosition="start" label="View Request" />
        {isprovider === 'yes' && (<Tab value="pendingComments" icon={<Comment />} iconPosition="start" label="Open Requests" />)}
        {isAdmin && <Tab value="pendingApproval" icon={<PendingActions />} iconPosition="start" label="Pending Approval" />} 
        {isAdmin && <Tab value="feedbacks" icon={<Reviews />} iconPosition="start" label="Feedback & Issues" />}
      </Tabs>

      <Box sx={{ mb: 2.5 }}>
        <Typography variant="h5" sx={{ color: '#0f172a', fontWeight: 900 }}>
          {viewTitleMap[view]}
        </Typography>
        <Typography sx={{ color: '#64748b', mt: 0.75, maxWidth: 820 }}>
          {viewDescriptionMap[view]}
        </Typography>
      </Box>

      {view === 'raise' && (
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            bgcolor: '#f8fafc',
            border: '1px solid #e2e8f0',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
              gap: 2,
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Request To</InputLabel>
              <Select disabled={isEditing} value={requestTo} onChange={handleRequestToChange} label="Request To">
                <MenuItem value="Providers">Providers</MenuItem>
                <MenuItem value="Moderators">Moderators</MenuItem>
              </Select>
            </FormControl>
            {requestTo === 'Moderators' && (
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select value={moderatorType} onChange={(e) => setModeratorType(e.target.value)} label="Type">
                <MenuItem value="Feedback">Feedback</MenuItem>
                <MenuItem value="Issue">Issue</MenuItem>
              </Select>
            </FormControl>
            )}
            {requestTo === 'Providers' && (
            <> 
            <FormControl fullWidth>
              <InputLabel>What help you need ?*</InputLabel>
              <Select value={helpneed} onChange={(e) => sethelpneed(e.target.value)} label="What help you need ?">
              {helpneedlst.map((ind) => <MenuItem key={ind} value={ind}>{ind}</MenuItem>)}
              </Select>
             </FormControl> 
             <FormControl fullWidth>
              <InputLabel>Industry *</InputLabel>
              <Select value={industry} onChange={(e) => setIndustry(e.target.value)} label="Industry">
              {industries.map((ind) => <MenuItem key={ind} value={ind}>{ind}</MenuItem>)}
              </Select>
             </FormControl> 
            <FormControl fullWidth>
            <InputLabel>Criticality</InputLabel>
            <Select
              value={criticality}
              onChange={(e) => setCriticality(e.target.value)}
              label="Criticality"
            >
              <MenuItem value="Low">Low</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="High">High</MenuItem>
            </Select>
            </FormControl>
            {criticality === 'High' && (
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Justification for High Criticality"
                value={justification}
                onChange={(e) => setJustification(e.target.value)}
                sx={{ gridColumn: { xs: '1', md: '1 / -1' } }}
              />
            )} 
            </>
            )}
            {requestTo&&(
              <TextField
              fullWidth
              multiline
              rows={4}
              label={
                requestTo === 'Moderators'
                  ? moderatorType === 'Feedback' ? 'Your Feedback' :
                    moderatorType === 'Issue' ? 'Describe the Issue' :
                    'What do you want to share?'
                  : 'What help do you need?'
              }
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              sx={{ gridColumn: '1 / -1' }}
            />
            )} 
            {requestTo === 'Providers' && (
           <FormControl fullWidth sx={{ gridColumn: '1 / -1' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: { xs: 'stretch', sm: 'center' },
                gap: 1.5,
                flexWrap: 'wrap',
                p: 2,
                borderRadius: 2,
                border: '1px dashed #94a3b8',
                bgcolor: '#ffffff',
              }}
            >
              {/* Upload Button */}
              <Button
                variant="outlined"
                component="label"
                sx={{
                  mb: 0,
                  borderColor: '#0f766e',
                  color: '#0f766e',
                  fontWeight: 800,
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Upload Attachment
                <input
                    type="file"
                    hidden
                    multiple
                    accept=".pdf,.doc,.docx"
                    onChange={e => {
                      const filesArray = Array.from(e.target.files);
                      setResumeFiles(prev => [...prev, ...filesArray]);
                    }}
                  />
              </Button>
              {/* Show existing uploaded resume link */}
              {uploadedResumeFiles?.map((file, index) => (
                <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Link
                    href={`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${file.id}/download`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                  >
                    {file.filename}
                  </Link>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      setUploadedResumeFiles(prev => prev.filter((_, i) => i !== index));
                      setDeletedFileIds(prev => [...prev, file.id]); // Track deleted file
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
              {/* Show newly selected resume file */}
              {resumeFiles.length > 0 &&
              resumeFiles.map((file, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" noWrap maxWidth={200}>
                    {file.name}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setResumeFiles(prev => prev.filter((_, i) => i !== index));
                    }}
                    color="error"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}

              {/* Show message if no file at all */}
              {!uploadedResumeFiles && resumeFiles.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No attachment
                </Typography>
              )}
            </Box>
           </FormControl>
             
            )}
           
            <Box sx={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
                sx={{
                  minWidth: { xs: '100%', sm: 180 },
                  borderRadius: 999,
                  py: 1.2,
                  fontWeight: 900,
                  bgcolor: '#0f766e',
                  '&:hover': { bgcolor: '#115e59' },
                }}
              >
                {isEditing ? 'Update Request' : 'Submit Request'}
              </Button>
            </Box>
          </Box>
        </Paper>
      )}

      {['view', 'pendingApproval', 'pendingComments','feedbacks'].includes(view) && (
        <Box sx={{ mt: 2 }}>
          {isMobile && (
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              {requests.length === 0 ? (
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    border: '1px solid #e2e8f0',
                    bgcolor: '#f8fafc',
                    textAlign: 'center',
                  }}
                >
                  <Typography sx={{ color: '#0f172a', fontWeight: 800 }}>No requests found</Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', mt: 0.75 }}>
                    Try another tab or raise a new request.
                  </Typography>
                </Paper>
              ) : (
                requests.map((request) => (
                  <Paper
                    key={request.id}
                    elevation={0}
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      border: '1px solid #e2e8f0',
                      bgcolor: '#ffffff',
                      boxShadow: '0 10px 28px rgba(15, 23, 42, 0.06)',
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'flex-start' }}>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800 }}>
                          {request.request_number || request.moderatorType || 'Request'}
                        </Typography>
                        <Typography sx={{ color: '#0f172a', fontWeight: 900, mt: 0.25 }}>
                          {view === 'feedbacks' ? request.moderatorType : request.helpneed || request.industry || 'Community request'}
                        </Typography>
                      </Box>
                      <Chip
                        size="small"
                        label={request.status || request.moderatorType || 'Open'}
                        color={
                          request.status === 'Pending Approval' ? 'warning' :
                          request.status === 'Approved' ? 'success' :
                          request.status === 'Rejected' ? 'error' : 'default'
                        }
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#475569',
                        mt: 1.25,
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {request.question}
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mt: 1.5 }}>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800 }}>Submitted by</Typography>
                        <Typography variant="body2" sx={{ color: '#334155', fontWeight: 700 }}>{request.submittedBy || 'NA'}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800 }}>Submitted on</Typography>
                        <Typography variant="body2" sx={{ color: '#334155', fontWeight: 700 }}>{formatSubmittedDate(request.submittedDate)}</Typography>
                      </Box>
                    </Box>
                    {renderMobileActions(request)}
                  </Paper>
                ))
              )}
            </Box>
          )}

          {!isMobile && (
          <Paper
            elevation={0}
            sx={{
              height: 520,
              borderRadius: 3,
              border: '1px solid #e2e8f0',
              overflow: 'hidden',
            }}
          >
          <DataGrid
            rows={requests}
            columns={view === 'feedbacks' ? feedbackColumns : columns}
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 15]}
            paginationModel={{ pageSize, page }}
            onPaginationModelChange={(model) => {
              setPage(model.page);
              setPageSize(model.pageSize);
            }}
            //rowsPerPageOptions={[5, 10, 15]}  // Row options for mobile
            //onPageSizeChange={(newSize) => setPageSize(newSize)}
            getRowId={(row) => row.id} 
            disableRowSelectionOnClick
            sx={{
              border: 0,
              bgcolor: '#ffffff',
              '& .wrap-text': {
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                overflow: 'hidden',
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowY: 'auto',
              },
              '& .MuiDataGrid-root': {
                overflowX: 'auto',
              },
              '& .MuiDataGrid-columnHeaders': {
                minHeight: '48px',
                bgcolor: '#f8fafc',
                color: '#0f172a',
                fontWeight: 900,
                borderBottom: '1px solid #e2e8f0',
              },
              '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 900 },
              '& .MuiDataGrid-row:hover': { bgcolor: '#f0fdfa' },
              '& .MuiTablePagination-toolbar': {
                flexWrap: 'wrap',         // Allows content to wrap on small screens
                justifyContent: 'center', // Center-aligns the pagination controls
              },
            }}
          />
          </Paper>
          )}
        </Box>
      )}


      <Dialog
        open={!!selectedRequest}
        onClose={() => setSelectedRequest(null)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{ sx: { borderRadius: { xs: 0, sm: 3 } } }}
      >
        <DialogTitle sx={{ fontWeight: 900, color: '#0f172a', pb: 1 }}>Request Details</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          {selectedRequest && (
            <>
              {view !== 'feedbacks' &&(
                <>
                  <Typography><strong>Help Need:</strong> {selectedRequest.helpneed}</Typography>
                  <Typography><strong>Industry:</strong> {selectedRequest.industry}</Typography>
                  <Typography><strong>Criticality:</strong> {selectedRequest.criticality}</Typography>
                  {selectedRequest.criticality === 'High' && (
                    <>
                      <Typography><strong>Justification:</strong> {selectedRequest.justification}</Typography>               
                    </>
                  )}
                  <Typography><strong>Request:</strong> {selectedRequest.question}</Typography>
                  <Typography><strong>Status:</strong> {selectedRequest.status}</Typography>
                </> 
              )}      
              {view === 'feedbacks' &&(
                <>
                  <Typography><strong>Type:</strong> {selectedRequest.moderatorType}</Typography>
                  <Typography><strong>Comments:</strong> {selectedRequest.question}</Typography>
                </> 
              )} 
              <Typography><strong>Attachments:</strong>
              {uploadedResumeFiles?.map((file, index) => (
                <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Link
                    href={`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${file.id}/download`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                  >
                    {file.filename}
                  </Link>
                </Box>
              ))}
              </Typography>
              <Typography><strong>Submitted By:</strong> {selectedRequest.submittedBy}</Typography>
              <Typography>
                <strong>Submitted On:</strong>{' '}
                {formatSubmittedDate(selectedRequest.submittedDate)}
              </Typography>
              {answers?.length>0 && (
                <>
                  {/* <Typography><strong>Answer:</strong> {selectedRequest.answer}</Typography>
                  <Typography><strong>Answered By:</strong> {selectedRequest.answeredBy}</Typography> */}
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 900, color: '#0f172a' }}>Answers</Typography>
                    {answers?.length > 0 ? (
                        answers.map((ans, index) => (
                        <Box key={index} sx={{ mb: 1, p: 1.5, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: '#f8fafc' }}>
                          <Typography><strong>{ans.answeredBy}</strong> ({dayjs(ans.answeredDate).format('YYYY-MM-DD HH:mm')}):</Typography>
                          <Typography>{ans.answer}</Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography>No answers yet.</Typography>
                    )}
                  </Box>
                </>
              )}
              {view === 'pendingComments' && selectedRequest.status === 'Approved' && (
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Your Answer"
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  sx={{ mt: 2 }}
                />
              )}
              {selectedRequest.status==='Closed'&&(
                <>
                <Typography variant="h6">Closer Info:</Typography>
                <Typography><strong>Closed By:</strong> {selectedRequest.closedBy}</Typography>
                <Typography><strong>Closed On:</strong>  ({dayjs(selectedRequest.closedDate).format('YYYY-MM-DD HH:mm')})</Typography>
                <Typography><strong>Comments:</strong> {selectedRequest.closeComment}</Typography>
                </> 
              )}
               
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e2e8f0' }}>
          {view === 'pendingComments' && selectedRequest?.status === 'Approved' && (
            <Button
              onClick={() => handleAnswerSubmit(selectedRequest.id,selectedRequest.request_number)}
              disabled={!answer}
              variant="contained"
              sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' }, fontWeight: 800 }}
            >
              Submit Answer
            </Button>
          )}
          <Button onClick={() => {setSelectedRequest(null);setAnswers(null)}} sx={{ fontWeight: 800 }}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        PaperProps={{ sx: { borderRadius: { xs: 0, sm: 3 } } }}
      >
        <DialogTitle sx={{ fontWeight: 900, color: '#0f172a' }}>Close Request</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
            Add a short closure note so everyone understands how this request was resolved.
          </Typography>
          <TextField
            label="Close Comment"
            fullWidth
            multiline
            minRows={3}
            value={closeComment}
            onChange={(e) => setCloseComment(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e2e8f0' }}>
          <Button onClick={() => setCloseDialogOpen(false)} sx={{ fontWeight: 800 }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleCloseRequest}
            sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' }, fontWeight: 800 }}
          >
            Submit
          </Button>
        </DialogActions>
    </Dialog>

        </Paper>
      </Box>
    </Box>
  );
};

export default Request;
